import Button, { ButtonProps } from "@mui/material/Button";
import { FunctionComponent } from "react";
import { useTheme } from "@mui/material/styles";

interface IStyledButtonProps {
  spacing?: number;
  wrap?: boolean
}

export const StyledButton: FunctionComponent<ButtonProps & IStyledButtonProps> = ({
  children,
  spacing = 2,
  sx,
  wrap,
  ...rest
}) => {
  const theme = useTheme();
  return (
    <Button
      {...rest}
      sx={{
        minWidth: "100px !important",
        padding: "6px 16px !important",
        borderRadius: "4px !important",
        marginLeft: theme.spacing(spacing),
        textTransform: "none",
        whiteSpace:(wrap && wrap === true ? "normal" : "nowrap"),
        "&.Mui-disabled": {
          opacity: 0.5,
          //@ts-ignore
          backgroundColor:sx?.bgcolor || theme.palette.action.disabledBackground,
          //@ts-ignore
          color: sx?.color || theme.palette.action.disabled,
        },

        "&.MuiButton-containedSecondary": {
          backgroundColor: "var(--important-red) ",
          color: "var(--kyocera-white)",
        },
        "&:hover": {
          //@ts-ignore
          backgroundColor:sx?.bgcolor || theme.palette.primary.main,
          //@ts-ignore
          color: sx?.color || theme.palette.primary.contrastText,
        },
        ...sx,
      }}
    >
      {children}
    </Button>
  );
};
